/* Prices are rendered by Shopify in the active market currency. Quantity X remains the checkout authority. */
(function () {
  function update(event) {
    var variant = event.detail && event.detail.variant;
    if (!variant) return;
    document.querySelectorAll('[data-fb-native-table]').forEach(function (box) {
      if (!box.querySelector('[data-fb-tier-variant="' + variant.id + '"]')) return;
      box.querySelectorAll('[data-fb-tier-variant]').forEach(function (table) {
        table.hidden = table.dataset.fbTierVariant !== String(variant.id);
      });
    });
  }
  document.addEventListener('variant:change', update);
})();
